export default __webpack_public_path__ + "static/media/pool.f0b97676.svg";